export function shouldOpenAtSessionStart(announcements = []) {
    return announcements.some((announcement) => (
        !announcement.isSeen || announcement.frequency === 'everySessionStart'
    ))
}
